<form
  [formGroup]="form()"
  class="flex flex-col gap-4"
  [attr.data-testid]="'project-charter-time-frame-form-' + itemKey()"
>
  <div class="grid grid-cols-3 gap-4 mb-4">
    <div class="col">
      <app-form-field
        id="{{ 'milestone-' + itemKey() }}"
        fieldName="milestone"
        [placeholder]="'project.steps.projectCharter.timeFrame.milestone' | transloco"
        label="project.steps.projectCharter.timeFrame.milestone"
        data-testid="project-charter-time-frame-form-milestone"
        [disabledSignal]="disabled"
      >
      </app-form-field>
    </div>

    <div class="col">
      <app-form-field-datepicker
        id="{{ 'startDate-' + itemKey() }}"
        fieldName="startDate"
        type="datePicker"
        label="project.steps.projectCharter.timeFrame.startDate"
        data-testid="project-charter-time-frame-form-startDate"
        [isReadOnly]="disabled()"
      >
      </app-form-field-datepicker>
    </div>

    <div class="col" [ngClass]="{'ng-invalid ng-dirty': isEndDateBeforeStartDate()}">
      <app-form-field-datepicker
        id="{{ 'estimatedEndDate-' + itemKey() }}"
        fieldName="estimatedEndDate"
        type="datePicker"
        label="project.steps.projectCharter.timeFrame.endDate"
        data-testid="project.steps.projectCharter.timeFrame.endDate"
        [isReadOnly]="disabled()"
      >
      </app-form-field-datepicker>
    </div>
  </div>

  @if (
    isEndDateBeforeStartDate() &&
    (form().get('estimatedEndDate')?.touched || form().get('estimatedEndDate')?.dirty)
  ) {
    <div class="text-red-500 text-sm mb-4" data-testid="date-range-error">
      {{ 'project.steps.projectCharter.timeFrame.dateRangeError' | transloco }}
    </div>
  }

  @if (
    isEndDateBeforePrecedingEndDate() &&
    (form().get('estimatedEndDate')?.touched || form().get('estimatedEndDate')?.dirty)
  ) {
    <div class="text-red-500 text-sm mb-4" data-testid="date-range-error">
      {{ 'project.steps.projectCharter.timeFrame.precedingEndDateError' | transloco }}
    </div>
  }

  <div class="form-group mb-4">
    <label [for]="'stageDescription-' + itemKey()" class="block text-sm font-medium mb-2">
      {{ 'project.steps.projectCharter.timeFrame.stageDescription' | transloco }}
    </label>
    <textarea
      pTextarea
      [id]="'stageDescription-' + itemKey()"
      formControlName="stageDescription"
      class="w-full"
      rows="3"
      [attr.data-testid]="'stage-description-input-' + itemKey()"
    ></textarea>
  </div>

  <div class="flex justify-end mt-4" style="height: 39px">
    @if (canSave()) {
      <app-project-step-save-button
        [loading]="isSaving()"
        [disabled]="isSaving()"
        (clicked)="onSave()"
      ></app-project-step-save-button>
    }
  </div>
</form>
